import React from 'react';
import {LocateOutline} from 'react-ionicons';

const Loader = () => (
    <div className={'loaderspace'}>
        <LocateOutline rotate height="35px" width="35px" size={35} color={'black'} />
    </div>
)

export default Loader;